import React from 'react';
import autoBind from 'react-autobind';
import UserNotification from './Common/UserNotification.jsx';
import ApplicationActions from '../actions/ApplicationActions';
import ContentService from '../services/ContentService';
import SaveApplicationNotificationStore from '../stores/SaveApplicationNotificationStore';

function getState() {
    return {
        message: ContentService.getContent().saveApplicationNotification,
        showNotifiction: SaveApplicationNotificationStore.getShowNotifiction()
    };
}

class SaveApplicationNotification extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
    }
    componentDidMount() {
        SaveApplicationNotificationStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        SaveApplicationNotificationStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getState());
    }

    toggleNotification() {
        ApplicationActions.toggleSaveApplicationNotification();
    }

    render() {
        return (
            <UserNotification id="saveApplicationNotification"
                className="top-sticky-user-notification"
                message={this.state.message}
                onClick={this.toggleNotification}
                isHidden={!this.state.showNotifiction}
                hideIcon={true}/>);
    }
}

export default SaveApplicationNotification


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/SaveApplicationNotification.jsx